<template>
  <form autocomplete="off">
    <div class="fundingNeedsPurpose">
      <p class="fundingNeedsTitle">{{ t('fundingGroup') }}</p>
      <p class="fundingNeedsSubtitle">{{ t('fundingGroupHelper') }}</p>
      <visual-picker-group
        id="plan-to-use-funds"
        class="fundingGroup"
        v-validation:changed="['requiredFunding']"
        v-model="fundingPurposes.value"
        :options="fundsOptions"
      ></visual-picker-group>
    </div>

    <combined-element class="fundingNeedsOtherPurposes" v-if="gotOtherReasons">
      <input-text
        id="funds-for-other-purpuses"
        v-model="fundingPurposesOther.value"
        :maxlength="FUNDING_PURPOSES_OTHER_REASON_MAX_LENGTH"
        v-validation="[['dynamic', '/_extension/fundingPurposesOther']]"
      >
        <template #label>
          <div class="fundingOtherReasonsTitle">{{ t('otherPlans.title') }}</div>
        </template>
        <div class="fundingOtherReasons" slot="description">
          <div class="fundingOtherReasonsDescription">
            {{ t('otherPlans.description') }}
          </div>
        </div>
      </input-text>
    </combined-element>
  </form>
</template>

<script>
import * as funds from '@/modules/funds';
import { mapGetters, mapActions } from 'vuex';
import { FUNDING_PURPOSES_OTHER_REASON_MAX_LENGTH } from '@/modules/validation-service/fields-length';

import CombinedElement from '@/components/CombinedElement';
import applicationMixin from '@/mixins/application';
import mapConstsToOptions from '@/utils/map-consts-to-options';
import buildTranslators from '@/utils/build-translators';

export default {
  name: 'funding-purposes',

  components: {
    CombinedElement,
  },

  data() {
    const self = this;
    return {
      FUNDING_PURPOSES_OTHER_REASON_MAX_LENGTH,
      fundingPurposes: {
        get value() {
          return self?.uiApplicationState?.fundingPurposes ?? [];
        },
        set value(newValue) {
          self.updateUIStateApplication({
            ...self.uiApplicationState,
            fundingPurposes: newValue,
          });
        },
      },
      fundingPurposesOther: {
        get value() {
          return self?.uiApplicationState?._extension?.fundingPurposesOther ?? '';
        },
        set value(newValue) {
          self.updateUIStateApplication({
            ...self.uiApplicationState,
            _extension: {
              ...self.uiApplicationState._extension,
              fundingPurposesOther: newValue,
            },
          });
        },
      },
    };
  },

  computed: {
    ...mapGetters('application', { uiApplicationState: 'getUiStateApplication' }),
    fundsOptions() {
      return mapConstsToOptions(Object.values(funds), 'fundingPurposes.fundings');
    },
    gotOtherReasons() {
      return (
        Array.isArray(this.application.fundingPurposes) &&
        this.application.fundingPurposes.includes(funds.OTHER)
      );
    },
  },

  mixins: [applicationMixin],

  methods: {
    t(key, options) {
      return buildTranslators('fundingPurposes').t(key, options);
    },
    ...mapActions('application', ['updateUIStateApplication']),
  },
};
</script>

<style lang="sass" scoped>
.fundingNeeds
  h1
    margin-bottom: $glass-spacing-3
  .nextButton
    margin-top: $glass-spacing-4

.fundingNeedsTitle
  +font-size(16)
  margin-bottom: $glass-spacing-1
  color: $color-system-neutral-gray-6

.fundingNeedsSubtitle
  +font-size(13.33)
  margin: $glass-spacing-1 0
  color: $color-system-neutral-gray-5


.fundingNeedsAmount
  margin-top: $glass-spacing-4

.fundingNeedsPurpose
  margin-top: $glass-spacing-4

.fundingSelectionCaption
  margin-top: $glass-spacing-1
  text-transform: none
  font-weight: normal
  font-style: italic
  line-height: 1.33
  color: red
  +font-size(13.33)

.fundingNeedsOtherPurposes
  margin-top: $glass-spacing-4
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background-color: $color-system-neutral-white
  padding-left: $glass-spacing-0125

.fundingOtherReasonsTitle
  font-weight: bold

.fundingOtherReasons
  margin: $glass-spacing-105 0

.fundingOtherReasonsLabel
  +font-size(16)
</style>
